// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2bTcA","img-footer":"Footer_img-footer__2nKIW","footer__author-link":"Footer_footer__author-link__9EIL4"};